import { gql } from "@apollo/client";

const RESTORE_TOURNAMENT = gql`
  mutation restoreTournament($id: Float!) {
    restoreTournament(id: $id) {
      id
      title
    }
  }
`;

export default RESTORE_TOURNAMENT;
